import * as React from 'react';
import Modal from '../../../misc/components/modal';
import { AuditModalBody } from '../../../auditmodal/components/AuditModalBody';
import { CoughSession } from 'webportalclient';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';

export interface TrackingNumberModalProps {
    record: CoughSession;
    onClose: () => void;
}

export const TrackingNumberModal = (props: TrackingNumberModalProps) => {
    const [trackingNumber, setTrackingNumber] = React.useState(null);
    const [auditModalVisible, setAuditModalVisible] = React.useState(false);
    const client = useWebPortalApiClient();

    const trackingNumberSelector = (record: CoughSession): string => record ? record.postalTrackingNumber : null;

    const initialTrackingNumber = trackingNumberSelector(props.record);

    const handleChange = (event) => {
        setTrackingNumber(event.target.value);
    }

    const handleSave = () => {
        if (initialTrackingNumber) {
            setAuditModalVisible(true);
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = async (auditAnnotation?: string) => {
        await client.client.patchCoughSession({
            postalTrackingNumber: trackingNumber
        }, props.record.id, auditAnnotation);
        setAuditModalVisible(false);
        props.onClose();
    }

    const renderForm = () => {
        return (
            <>
                <div className='modal-body'>
                    <div className='row'>
                        <div className='col-md-12 form-group'>
                            <input className="form-control" defaultValue={initialTrackingNumber} onChange={handleChange} />
                        </div>
                    </div>
                </div>
                <div className='modal-footer'>
                    <button className='btn btn-primary' onClick={() => handleSave()}>
                        {initialTrackingNumber ? "Edit" : "Add"}
                    </button>
                    <button className='btn btn-primary btn-outline' onClick={() => props.onClose()}>Close</button>
                </div>
            </>
        );
    }

    const renderAuditModal = () => {
        return (
            <AuditModalBody
                isSubmitting={false}
                onClose={() => props.onClose()}
                onSubmit={(auditForm) => handleSubmit(auditForm.Annotation)}
            >
            </AuditModalBody>
        );
    }

    if (props.record.id) {
        return (
            <Modal show={true} closeModalHandler={() => props.onClose()} header="Tracking Number">
                {auditModalVisible ? renderAuditModal() : renderForm()}
            </Modal>
        );
    } else {
        return null;
    }
}
